import React from 'react';
import Footer from '../component/Footer';

const Surgery = () => {
    return (
        <>
            <div className="container">
               
                <div className="text-center my-5">
                    <h1>General Surgery</h1>
                </div>

              
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            General surgery involves a wide range of procedures, from routine surgeries
                            to complex operations. Our surgical team is dedicated to providing the best
                            care for a variety of conditions.
                        </p>
                        <p>
                            We specialize in abdominal surgeries, thyroid operations, and surgeries related to the gastrointestinal system.
                        </p>
                        <p>
                            With our state-of-the-art facilities and highly skilled surgeons, we ensure that each patient receives personalized care
                            before, during, and after their surgery.
                        </p>
                    </div>
                </div>
            </div>

   
            <Footer />
        </>
    );
}

export default Surgery;
